/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=f8289ad8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f8289ad8&lang=css"
import "./App.vue?vue&type=style&index=1&id=f8289ad8&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__